<template>
	<div class="vw-flat-rate-search-results-view">
		<InfiniteScroller
			:loading="loading"
			@scrollBoundary="getNextPage"
			:hasMoreResults="hasMoreResults"
			:wheelElement="tableElement"
			:scrollElement="tableContainer"
		>
			<template v-slot:scrollDiv>
				<div>
					<TableSection
						:sectionsData="recordset"
						ref="table"
						:responsive="false"
						@addLaborCode="onAddLaborCode"
						@mounted="tableMounted"
					>
					</TableSection>

					<template>
						<NoResultsMessage
							:hasSearchFilter="hasSearchFilter"
							:visible="!hasResults"
							primaryTextCondensed="No Labor Operation Codes to display."
							secondaryTextCondensed="Search a Keyword or Labor Code to return results."
						/>
					</template>
				</div>
			</template>
		</InfiniteScroller>
	</div>
</template>

<script>
import TableSection from './vw-flat-rate-results-table-sections.vue';

import { mapGetters } from 'vuex';
import NoResultsMessage from '@/components/shells/no-results-message/no-results-message.vue';
import columns from './vw-flat-rate-columns';
import { ASC } from '@/components/shells/table/sort-directions';

import InfiniteScroller from '@/components/shells/infinite-scroller/infinite-scroller.vue';

export default {
	name: 'VWFlatRateSearchResults',
	components: {
		NoResultsMessage,

		TableSection,

		InfiniteScroller
	},
	data() {
		return {
			sortBy: 'laborOpNumber',
			sortDirection: ASC,
			currentPage: 1,
			infiniteScrollElement: undefined,
			tableElement: undefined,
			defectCodesVisibleRecordId: 0,
			addLaborCodeTooltipVisibleId: 0
		};
	},
	props: {
		recordset: {
			type: Array,
			default: () => []
		},
		loading: {
			type: Boolean,
			default: false
		},
		hasSearchFilter: {
			type: Boolean,
			default: false
		},
		hasMoreResults: {
			type: Boolean,
			default: false
		}
	},
	async created() {},
	computed: {
		...mapGetters('vwFlatRate', ['selectedLaborCodes']),
		tableContainer() {
			return this.infiniteScrollElement;
		},
		tableColumns() {
			const tempColumns = [...columns];
			let columnIndex;

			if (this.sortBy) {
				columnIndex = tempColumns.findIndex(
					c => c.columnName === this.sortBy
				);

				tempColumns[columnIndex].sortDirection = this.sortDirection;
			}

			return tempColumns;
		},
		hasResults() {
			return this.recordset?.length > 0;
		}
	},
	methods: {
		onSortTable(objSort) {
			this.$emit('sort', {
				columnName: objSort.columnName,
				sortDirection: objSort.sortDirection
			});
		},
		onViewDefectCodes(id) {
			this.defectCodesVisibleRecordId = id;
		},
		onCloseDefectCodes() {
			this.defectCodesVisibleRecordId = 0;
		},

		onAddDefectCode(defectCode) {
			this.$emit('addDefectCode', defectCode);
			this.onCloseDefectCodes();
		},
		onAddLaborCode(laborRateRecord) {
			this.$emit('addLaborCode', laborRateRecord);
		},
		addLaborCodeDisabled(id) {
			return this.selectedLaborCodes.some(code => code.id === id);
		},
		getNextPage() {
			this.currentPage++;
			this.$emit('nextPage', this.currentPage);
		},
		tableMounted(tableReferences) {
			if (tableReferences) {
				this.infiniteScrollElement = tableReferences.tableContainer;
				this.tableElement = tableReferences.table;
			}
		},
		onMouseEnterAddLaborCode(id) {
			this.addLaborCodeTooltipVisibleId = id;
		},
		onMouseLeaveAddLaborCode() {
			this.addLaborCodeTooltipVisibleId = 0;
		},
		isAddLaborCodeToolTipVisible(id) {
			if (this.addLaborCodeDisabled(id)) {
				return this.addLaborCodeTooltipVisibleId === id;
			}
			return false;
		}
	}
};
</script>

<style lang="scss" scoped>
@include scrollbar(
	'borderless',
	'.vw-flat-rate-search-results-view__popover-items'
);
.vw-flat-rate-search-results-view {
	&__popover-items {
		display: flex;
		flex-direction: column;
		gap: $gutter-md;
		width: 100%;
		overflow: auto;
		max-height: 300px;
		border: 1px solid var(--neutral-2);
	}

	&__add-btn {
		font-size: $txt-font-size;
	}

	&__popover-item {
		display: flex;
		align-items: center;
	}

	&__description {
		overflow-wrap: break-word;
		word-break: break-all;
		max-width: 250px;

		@include mq($from: lg) {
			max-width: 480px;
		}
	}

	&__defect-code {
		font-size: $txt-font-size;
	}

	&:deep(.table__td) {
		vertical-align: middle;
	}

	&:deep(.table__th--labor-code),
	&:deep(.table__td--labor-code) {
		width: 109px;
	}

	&:deep(.table__th--description),
	&:deep(.table__td--description) {
		width: auto;
	}

	&:deep(.table__th--flat-rate-time),
	&:deep(.table__td--flat-rate-time) {
		width: 63px;
	}

	&:deep(.table__th--defect-codes),
	&:deep(.table__td--defect-codes) {
		width: 103px;
		text-align: center;
	}

	&:deep(.table__th--add-labor-code),
	&:deep(.table__td--add-labor-code) {
		width: 39px;
		padding: $gutter-md 0;
	}

	&:deep(.table__td--add-labor-code) {
		display: inline-flex;
		align-items: center;
		justify-content: center;
	}

	&__labor-code-btn {
		display: inline-flex;
		align-items: center;
		justify-content: center;

		&:deep(.btn-small) {
			min-width: 0;
		}
	}

	&__labor-code-icon {
		font-size: $table-icon-font-size;
	}
}
.tooltip {
	pointer-events: none;
}
</style>
